<template>
    <el-dialog title="" :visible.sync="dialogVisibleImage" @close="closeDialog">
        <div style="display:flex;align-items: center;justify-content: center;">
            <div style="width: 100%;">
                <div v-if="previewType.indexOf('.pdf') > 0 || previewType.indexOf('.PDF') > 0">
                    <PdfImage :url="dialogImageUrl" />
                </div>
                <div style="display:flex;align-items: center;justify-content: center;" v-else>
                    <el-image :src="dialogImageUrl" :preview-src-list="[dialogImageUrl]"></el-image>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import PdfImage from './pdf-image.vue';
export default {
    name: 'pdf-preview',
    props: {
        dialogVisibleImage: {
            type: Boolean,
            default: false
        },
        dialogImageUrl: {
            type: String,
            default: ''
        },
        previewType: {
            type: String,
            default: ''
        },
    },
    components: {
        PdfImage,
    },
    methods: {
        closeDialog() {
            this.$emit('close');
        },
    },
}

</script>